
import { MapElementType, InfosDraw } from "@/utils/constant/settings_constantes";
import * as turf from "@turf/turf";

export default class Map_DynamicElementPolygon {
  geom;
  insertPoint;
  isvalid;

  constructor(geom) {
    this.geom = geom;
    this.insertPoint = { position: undefined, index: 0 };
    this.isvalid = true;
  }

  getPointOnLine(cartographic) {
    let snapped = undefined;
    if (this.geom.controlspoints.length > 2) {
      if (Cesium.defined(cartographic)) {
        const pt = turf.point([cartographic.latitude, cartographic.longitude]);
        const line = this.getTurfLine();
        if(line != undefined) {
          snapped = turf.nearestPointOnLine(line, pt, { units: "kilometers" });
          snapped.properties.dist *= 1000;
        }
      }
    }
    return snapped;
  }

  async getBorderPicked() {
    if (
      this.geom.pickedInfos !== undefined &&
      this.geom.pickedInfos.position &&
      this.geom.viewer.canvas.style.cursor != "move"
    ) {
      const elem = this.getPointOnLine(this.geom.pickedInfos.position);
      if (elem !== undefined) {
        if (elem.properties.dist < this.geom.events.distmin) {
          const cartographic = new Cesium.Cartographic(
            elem.geometry.coordinates[1],
            elem.geometry.coordinates[0],
            this.geom.pickedInfos.position.height
          );
          //bug : insertpoint is picked
          //const height = await this.geom.pickRayCast(cartographic);
          //cartographic.height = height;
          if (Cesium.defined(cartographic)) {
            this.insertPoint = {
              position: cartographic,
              index: elem.properties.index,
            };
            return;
          }
        }
      }
    }
    this.insertPoint = { position: undefined, index: 0 };
  }

  addInsertPoint(id) {
    const entity = {
      position: new Cesium.CallbackProperty(() => {
        return this.getinsertPoint();
      }, false),
      ellipsoid: {
        radii: new Cesium.Cartesian3(1.0, 1.0, 1.0),
        material: Cesium.Color.WHITE.withAlpha(0.8),
        show: new Cesium.CallbackProperty(() => {
          return this.geom.events.isBorderHover();
        }, false),
      },
      allowPicking: false,
    };

    this.geom.datasource.entities.add(entity);
  }

  getinsertPointDistance() {
    let distance = Number.POSITIVE_INFINITY;
    if (this.geom.controlspoints.length > 1) {

      const c1 = this.geom.controlspoints[this.geom.controlspoints.length -1];
      const c2 = this.geom.controlspoints[this.geom.controlspoints.length -2];
      if(Cesium.defined(c1) && Cesium.defined(c2)) {
        const from = turf.point([c1.latitude, c1.longitude]);
        const to = turf.point([c2.latitude, c2.longitude]);
        distance = turf.distance(from, to, {units: 'kilometers'}) * 1000;
        distance += Math.abs(c2.height - c1.height);
      }
    }
    return distance;
  }

  getinsertPoint() {
    if (this.geom.events.isBorderHover()) {
      const cartesian = this.geom.cartesian3FromCartographicDegrees(
        this.insertPoint.position
      );
      return cartesian;
    }
    return new Cesium.Cartesian3.fromDegrees(0, 0, 0);
  }

  hideinsertPoint() {
    this.insertPoint = { position: undefined, index: 0 };
  }

  addPointToPoly() {
    this.geom.addControlPoint(
      this.insertPoint.position,
      this.insertPoint.index + 1
    );
    this.geom.forceUpdateInfos();
    this.hideinsertPoint();
  }

  removePointToPoly(index) {
    this.geom.removeControlPoint(index);
    this.geom.forceUpdateInfos();

    this.geom.events.updateCustomMapElement(true);
    this.geom.events.desactivateContexMenu();
    this.geom.events.setInfosDrawHelp(InfosDraw.RemovePoint);
  }

  // TURF
  getTurfPolygon() {
    let cartographics = [];

    if(this.geom.controlspoints.length < 2) {
      return undefined;
    }
    for (let i = 0; i < this.geom.controlspoints.length; i++) {
      const cartographic = this.geom.getControlPoint(i);
      cartographics.push([cartographic.latitude, cartographic.longitude]);
    }
    //close polygon
    cartographics.push(cartographics[0]);
    const poly = turf.polygon([cartographics]);
    return poly;
  }

  getTurfLine() {
    let cartographics = [];

    if(this.geom.controlspoints.length < 1) {
      return undefined;
    }
    this.geom.controlspoints.forEach((controlspoint) => {
      cartographics.push([controlspoint.latitude, controlspoint.longitude]);
    });
    if(this.geom.getType() === MapElementType.Polygone && this.geom.controlspoints.length > 2) {
      cartographics.push([this.geom.controlspoints[0].latitude, this.geom.controlspoints[0].longitude]);
    }
    const line = turf.lineString(cartographics);
    return line;
  }

  bufferLine(width) {
    const poly = this.getTurfLine();
    if(poly === undefined) {
      return undefined;
    }
    const buffered = turf.buffer(poly, width / 1000, {
      units: "kilometers",
      steps: 1,
    });
    return buffered;
  }

  getCentroid() {

    let point = undefined;
    if (this.geom.getType() === MapElementType.Polygone) {
      const poly = this.getTurfPolygon();
      if(poly === undefined) {
        return new Cesium.Cartesian3.fromDegrees(0, 0, 0);
      }
      point = turf.pointOnFeature(poly);
    }
    if (this.geom.getType() === MapElementType.Ligne) {
      const line = this.getTurfLine();
      if(line === undefined) {
        return new Cesium.Cartesian3.fromDegrees(0, 0, 0);
      }
      const length = turf.length(line, {units: 'kilometers'});
      point = turf.along(line, length / 2,  {units: 'kilometers'});
    }

    const cartesian = Cesium.Cartesian3.fromDegrees(
      point.geometry.coordinates[1],
      point.geometry.coordinates[0],
      0
    );
    if (Cesium.defined(cartesian)) {
      return cartesian;
    }
    return new Cesium.Cartesian3.fromDegrees(0, 0, 0);
  }

  isValid() {

    /*let poly = undefined;
    if (this.geom.getType() === MapElementType.Polygone) {
      poly = this.getTurfPolygon();
    }
    if (this.geom.getType() === MapElementType.Ligne) {
      poly = this.getTurfLine();
    }
    if(poly == undefined) {
      return false;
    }
    this.isvalid = turf.booleanValid(poly);*/
    return true;
  }

  getWKT() {
    let wkt = "";
    wkt = "POLYGON ((";
    this.geom.controlspoints.forEach((controlspoint) => {
      wkt +=
        controlspoint.longitude.toFixed(8) +
        " " +
        controlspoint.latitude.toFixed(8) +
        ",";
    });
    //close polygon
    wkt +=
      this.geom.controlspoints[0].longitude.toFixed(8) +
      " " +
      this.geom.controlspoints[0].latitude.toFixed(8) +
      ",";
    wkt = wkt.substring(0, wkt.length - 1);
    wkt += "))";
    return wkt;
  }

  getArea() {
    let area = 0;
    if (this.geom.controlspoints.length > 2) {

      //const poly = this.getTurfPolygon();
      //if(poly !== undefined) {
      //  area = turf.area(poly);
      //}
      const coordinates = this.geom.getControlPointArray(false, false);
      const cartesians = Cesium.Cartesian3.fromDegreesArrayHeights(coordinates);
      area = this.Get_Area(cartesians);

    }
    return area;
  }

  getLength() {
    let length = 0;
    /*
    let poly = undefined;
    if (this.geom.controlspoints.length > 2) {
      poly = this.getTurfPolygon();
      if(poly !== undefined) {
        length = turf.length(poly, { units: "kilometers" }) * 1000;
      }
    }*/
    const coordinates = this.geom.getControlPointArray(false, false);
    const cartesians = Cesium.Cartesian3.fromDegreesArrayHeights(coordinates);
    length = this.Get_Distance(cartesians);
    return length;
  }

  getEntityPolygon() {
    this.geom.material.alpha = 0.5;

    let entity = {
      position: new Cesium.CallbackProperty(() => {
        return this.geom.polygon.getCentroid();
      }, false),
      polygon: {
        hierarchy: new Cesium.CallbackProperty(() => {
          return this.geom.getGeomHeightWGS();
        }, false),
        material: this.geom.material.getPolyMaterial(),
        outline: true,
        outlineWidth: 2,
        outlineColor: this.geom.material.getPolylineMaterial(),
        show: new Cesium.CallbackProperty(() => {
          return this.geom.getVisibility();
        }, false),
        clampToGround: true,
        classificationType: Cesium.ClassificationType.BOTH,
        zIndex: 1,
      },
      polyline: {
        positions: new Cesium.CallbackProperty(() => {
          return this.geom.getGeomHeightWGS(true);
        }, false),
        material: this.geom.material.getPolylineMaterial(),
        width: 2,
        clampToGround: true,
        show: new Cesium.CallbackProperty(() => {
          return this.geom.getVisibility();
        }, false),
        classificationType: Cesium.ClassificationType.BOTH,
        zIndex: 2,
      },
      label: {
        text: new Cesium.CallbackProperty(() => {
          return this.geom.getName();
        }),
        fillColor: Cesium.Color.WHITE,
        showBackground: true,
        backgroundColor: Cesium.Color.BLACK.withAlpha(0.7),
        backgroundPadding: new Cesium.Cartesian2(17, 15),
        horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        style: Cesium.LabelStyle.FILL,
        show: new Cesium.CallbackProperty(() => {
          return (
            this.geom.events.isPicked() &&
            this.geom.events.isControlPointClickLeft() == false &&
            this.geom.getName() != "" &&
            this.geom.events.isInsert() == false &&
            this.geom.isTypeVisible(this.geom.getType())
          );
        }, false),
        scale: 0.4,
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
        heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        pixelOffset: new Cesium.Cartesian2(
          0,
          -this.geom.material.getSize() - 5
        ),
      },
    };
    entity.dynamic = this.geom;
    entity.show = true;
    return entity;
  }

  Get_Area(cartesians) {

    if (cartesians == undefined || cartesians.length < 3) {
      return 0;
    }
    let indices = Cesium.PolygonPipeline.triangulate(cartesians, []);
    let area = 0; // In square kilometers

    for (let i = 0; i < indices.length; i += 3) {
      let vector1 = cartesians[indices[i]];
      let vector2 = cartesians[indices[i + 1]];
      let vector3 = cartesians[indices[i + 2]];

      // These vectors define the sides of a parallelogram (double the size of the triangle)
      let vectorC = Cesium.Cartesian3.subtract(vector2, vector1, new Cesium.Cartesian3());
      let vectorD = Cesium.Cartesian3.subtract(vector3, vector1, new Cesium.Cartesian3());

      // Area of parallelogram is the cross product of the vectors defining its sides
      let areaVector = Cesium.Cartesian3.cross(vectorC, vectorD, new Cesium.Cartesian3());

      // Area of the triangle is just half the area of the parallelogram, add it to the sum.
      area += Cesium.Cartesian3.magnitude(areaVector) / 2.0;
    }

    return area;
  }

  Get_Distance(cartesians) {
    let dist = 0;
    let d = [];
    let postions = [];
    //if (cartesians.length > 0) {
    //  postions = cartesians.slice(0, cartesians.length - 1);
   // }
    for (var t = Cesium.EllipsoidTangentPlane.fromPoints(cartesians, Cesium.Ellipsoid.WGS84), i = t.projectPointsOntoPlane(cartesians, d), n = [], r = 0; r < i.length; r++)
      n.push({
        position: i[r],
        index: r
    });
    for (let r = 0; r < n.length - 1; r++) {
      dist += Cesium.Cartesian2.distance(n[r].position, n[r + 1].position);
    }
    return dist;
  }
}
